// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__b75acb764d2323cba6e7","cls2":"ImpactHubProfileCard-cls2__e496fdef472b75b8280f ImpactHubProfileCard-cls1__b75acb764d2323cba6e7"};